var _polygon, _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "85.286,68.62 73.333,80.566 68.047,75.286 63.333,80 73.333,90 90,73.333 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,23.333V90h46.667V63.333H90v-40H10z M30,53.333h6.667c5.521,0,10,4.479,10,10H46.66c0,5.521-4.473,9.994-9.994,10V80H30 v-6.667c-5.521,0-10-4.479-10-10h6.667c0,1.843,1.491,3.334,3.333,3.334h6.66c1.842,0,3.333-1.491,3.333-3.334H40 C40,61.491,38.509,60,36.667,60H30c-5.521,0-10-4.479-10-10c0-5.521,4.479-10,10-10v-6.667h6.667V40c5.521,0,10,4.479,10,10H40 c0-1.842-1.491-3.333-3.333-3.333H30c-1.842,0-3.333,1.491-3.333,3.333C26.667,51.843,28.158,53.333,30,53.333z M56.667,33.333 h16.666V40H56.667V33.333z M80,53.333H56.667v-6.667H80V53.333z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 6.667,
    height: 6.667
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.333,
    y: 10,
    width: 6.667,
    height: 6.667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.667,
    y: 10,
    width: 6.667,
    height: 6.667
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 10,
    width: 40,
    height: 6.667
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.b4e36d01.svg";
export { ForwardRef as ReactComponent };